import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

const RequestDetailField = ({ label, value, fullWidth, xs = 12, sm }) => {
  if (value == null || value === "") return null;
  return (
    <Grid item xs={xs} sm={sm ?? (fullWidth ? 12 : 6)}>
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        lineHeight={1.2}
        sx={{ mb: 0.25 }}
      >
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={500} lineHeight={1.35}>
        {value}
      </Typography>
    </Grid>
  );
};

RequestDetailField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  xs: PropTypes.number,
  sm: PropTypes.number,
};

export default RequestDetailField;
